import { useCallback, useEffect, type MutableRefObject } from 'react'
import { useEnrollmentStore, type EnrollmentFormData } from '@/stores'
import type { EligibilityFormData } from '../../../../components/eligibilitySteps/types'
import { buildEnrollmentDraftStorePatch } from '../../../../utils/enrollmentHydration'

type UseEnrollmentDraftSyncArgs = {
  formData: EligibilityFormData
  formDataRef: MutableRefObject<EligibilityFormData>
  updateEnrollmentStoreFormData: (data: Partial<EnrollmentFormData>) => void
}

export function useEnrollmentDraftSync({
  formData,
  formDataRef,
  updateEnrollmentStoreFormData
}: UseEnrollmentDraftSyncArgs) {
  const storedLocationState = useEnrollmentStore(state => state.formData.locationState)

  useEffect(() => {
    formDataRef.current = formData

    updateEnrollmentStoreFormData(
      buildEnrollmentDraftStorePatch(formData, {
        includeSelection: true,
        locationState: storedLocationState
      })
    )
  }, [formData, formDataRef, storedLocationState, updateEnrollmentStoreFormData])

  const syncStoreFormData = useCallback(
    (next: EligibilityFormData) => {
      updateEnrollmentStoreFormData(buildEnrollmentDraftStorePatch(next))
    },
    [updateEnrollmentStoreFormData]
  )

  return {
    syncStoreFormData
  }
}
